import React from "react";

export default function Footer() {
    return (
        <footer
            data-testid="footer"
            className="border-t border-[#e8e4dd] py-10 px-5 md:px-10 bg-[#f7f5f1]"
        >
            <div className="max-w-[1400px] mx-auto flex flex-col md:flex-row md:items-center md:justify-between gap-3">
                <p className="text-[13px] text-[#6b6b66]">
                    © {new Date().getFullYear()} Lionel Q. F. Soulton —
                    Consultant SEA / SMA
                </p>
                <p className="text-[13px] text-[#6b6b66] italic-serif">
                    Conçu avec rigueur, à Paris.
                </p>
            </div>
        </footer>
    );
}
